module.exports = __webpack_public_path__ + "assets/RetinaNarr-ThinItalic.f348742d639e6ef0734c3542fd4c23db.woff";